"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _useLink = require("../hooks/useLink");
var _jsxRuntime = require("react/jsx-runtime");
var LinkElement = exports.LinkElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["children", "className"]);
  var element = (0, _plateCommon.useElement)();
  var _ref2 = (0, _useLink.useLink)({
      element: element
    }),
    linkProps = _ref2.props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateCommon.PlateElement, _objectSpread({
    asChild: true,
    className: (0, _cn.cn)('font-medium text-primary underline decoration-primary underline-offset-4', className),
    ref: ref
  }, linkProps, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      children: children
    })
  }));
});